import { render, staticRenderFns } from "./ModalAddSchool.vue?vue&type=template&id=a2bf16b0&scoped=true"
import script from "./ModalAddSchool.vue?vue&type=script&lang=js"
export * from "./ModalAddSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bf16b0",
  null
  
)

export default component.exports